import { APP_CONFIG } from '../config/app.ts'

/**
 * Login de coordinador
 * @param email - Email del coordinador
 * @param password - Contraseña
 * @returns Token y datos de usuario
 */
export const loginCoordinador = async (email, password) => {
  try {
    const resp = await fetch(`${APP_CONFIG.apiUrl}/coordinadores/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    });
    
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error('Error en loginCoordinador:', error);
    return {
      success: false,
      error: true,
      msg: 'Error de conexión'
    };
  }
};

/**
 * Obtiene giras asignadas al coordinador
 * @param token - JWT token
 * @returns Array de giras
 */
export const obtenerMisGiras = async (token) => {
  try {
    const resp = await fetch(`${APP_CONFIG.apiUrl}/coordinadores/mis-giras`, {
      method: 'GET',
      headers: {
        'x-token': token
      }
    });
    
    const data = await resp.json();
    return data;
  } catch (error) {
    console.error('Error en obtenerMisGiras:', error);
    return {
      success: false,
      error: true,
      msg: 'Error al obtener giras',
      data: []
    };
  }
};
